import PropTypes from 'prop-types';
import { Container, Alert, AlertTitle } from '@mui/material';
import useAuth from '../hooks/useAuth';

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  children: PropTypes.node
};

const useCurrentRole = () => {
  // Logic here to get current user role
  const role = ['ADMIN'];
  return role;
};

export default function RoleBasedGuard({ children }) {
  const currentRole = useCurrentRole();
  const {user} = useAuth();

  if (!currentRole.includes(user?.type)) {
    return (
      <Container>
        <Alert severity="error">
          <AlertTitle>Permission Denied</AlertTitle>
          You do not have permission to access this page
        </Alert>
      </Container>
    );
  }

  return <>{children}</>;
}
